import { createFileRoute } from '@tanstack/react-router'
import { AuditPage } from '@/pages/audit/audit-page'

export const Route = createFileRoute('/audit')({
  component: AuditRoutePage,
})

function AuditRoutePage() {
  return <AuditPage />
}
